 import { initFbsdk } from '@/assets/config/facebook_oAuth.js';
export default {
    name: 'login',
    data() {
        return {
          
        }
    },
    mounted () {
        initFbsdk()
    },
    methods: {
        loginWithGoogle () {
            this.$gAuth
            .signIn()
            .then(GoogleUser => {
                // on success do something
                console.log('GoogleUser', GoogleUser)
                console.log('getId', GoogleUser.getId())
                console.log('getBasicProfile', GoogleUser.getBasicProfile())
                console.log('getAuthResponse', GoogleUser.getAuthResponse())
            }).catch(error => {
                console.log('error', error)
            })
        },
        logInWithFacebook() {
            window.FB.login(response => {
              console.log('fb response', response)
            }, this.params)
        }
       
          
    }
    
}